import MobileDetect from 'mobile-detect';

const inBrowser = typeof window !== 'undefined';
const getUserAgent = () => (inBrowser ? window.navigator.userAgent : '');
const getPlatform = () => (inBrowser ? window.navigator.platform : '');
const getMaxTouchPoints = () => (inBrowser ? window.navigator.maxTouchPoints : 0);
const getBrowserPossibleVersions = () => (inBrowser ? window.navigator.appVersion : '');
const getVendor = () => (inBrowser ? window.navigator.vendor : '');

const md = new MobileDetect(getUserAgent());

/**
 * Safari
 */

const isSafari = /^((?!chrome|android).)*safari/i.test(getUserAgent());
const iPadOS13Up = getPlatform() === 'MacIntel' && getMaxTouchPoints() > 1;
const isMac = getBrowserPossibleVersions().includes('Mac');
const isIOS = md ? md.os() === 'iOS' : false;
const isIphone = md ? md.is('iPhone') : false;
const isIpad = md ? md.is('iPad') : false;

/**
 * Google
 */
const isAndroid = getUserAgent().includes('Android');
const isChrome = /Chrome/.test(getUserAgent()) && /Google Inc/.test(getVendor());

/**
 * Generic
 */
const isMobile = md ? md.mobile() !== null : false;
const isTablet = md ? md.tablet() !== null || iPadOS13Up : false;
const isTabletOrMobile = isTablet || isMobile;
const isMobilePhone = isMobile && !isTablet;

/**
 * Mozilla
 */
const isFirefox = getUserAgent().toLowerCase().includes('firefox');

/**
 * Microsoft
 */

const isIE = getUserAgent().includes('MSIE ') || getUserAgent().includes('Trident/'); // IE 10 || IE 11

const isEdge = getUserAgent().includes('Edge/'); // Edge (IE 12+)

const getBrowserName = () => {
  if (isChrome) return 'Chrome';
  if (isFirefox) return 'Firefox';
  if (isSafari) return 'Safari';
  if (isEdge) return 'Microsoft Edge';
  if (isIE) return 'Internet Explorer';

  return 'Unknown';
};

const getDeviceName = () => {
  if (isAndroid) return 'Android';
  if (isIOS) return 'IOs';
  if (isIpad) return 'IOs (Ipad)';
  if (isMac) return 'Macintosh';

  return 'Desktop';
};

// https://gist.github.com/lyquix-owner/34a3ed98b990c3c61151d30de2f42702
// returns the browser name, type and version, and sets body classes
// detects major browsers: IE, Edge, Firefox, Chrome, Safari, Opera, Android
// based on: https://github.com/ded/bowser
// list of user agent strings: http://www.webapps-online.com/online-tools/user-agent-strings/dv
const getBrowserVersion = () => {
  const ua = getUserAgent();

  // helper functions to deal with common regex
  function getFirstMatch(regex: RegExp) {
    const match = ua.match(regex);
    return (match && match.length > 1 && match[1]) || '';
  }

  function getSecondMatch(regex: RegExp) {
    const match = ua.match(regex);
    return (match && match.length > 1 && match[2]) || '';
  }

  if (/opera|opr/i.test(ua)) {
    return (
      getFirstMatch(/version\/(\d+(\.\d+)?)/i) ||
      getFirstMatch(/(?:opera|opr)[\s/](\d+(\.\d+)?)/i)
    );
  }

  if (/msie|trident/i.test(ua)) {
    return getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i);
  }

  if (/chrome.+? edge/i.test(ua)) {
    return getFirstMatch(/edge\/(\d+(\.\d+)?)/i);
  }

  if (/chrome|crios|crmo/i.test(ua)) {
    return getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i);
  }

  if (/firefox/i.test(ua)) {
    return getFirstMatch(/(?:firefox)[ /](\d+(\.\d+)?)/i);
  }

  if (!/like android/i.test(ua) && /android/i.test(ua)) {
    return getFirstMatch(/version\/(\d+(\.\d+)?)/i);
  }

  if (/safari/i.test(ua)) {
    return getFirstMatch(/version\/(\d+(\.\d+)?)/i);
  }

  return getSecondMatch(/^(.*)\/(.*) /);
};

// This only works on browsers:
export {
  iPadOS13Up,
  isAndroid,
  isChrome,
  isEdge,
  isFirefox,
  isIE,
  isIpad,
  isIphone,
  isIOS,
  isMac,
  isMobile,
  isMobilePhone,
  isSafari,
  isTablet,
  isTabletOrMobile,
  getBrowserName,
  getBrowserVersion,
  getDeviceName,
};
